import { useLocation, useNavigate } from 'react-router-dom'
import { YoloBotGraphCSS } from './YoloBotGraphCSS.styled'
import { useEffect, useMemo, useState } from 'react'
import { LVG_ASSETS } from 'constants/games/lvg/lvgAssets'
import { PriceGraph } from 'components/Organisms/PriceGraph'
import { YolobotGraphHeader } from './BotGraph/HeaderManager'
import { config } from 'config'
import useScript from 'react-script-hook'

export const YoloBotGraph = () => {
  const location = useLocation()
  const navigateTo = useNavigate()
  const [assetInfo, setAssetInfo] = useState()

  const queryParams = new URLSearchParams(location.search)
  const coinSymbol = queryParams.get('cs')
  const graphId = queryParams.get('gi')

  const grphId = useMemo(() => Number(graphId.replace('g', '')), [graphId])
  const botUrlPlaceOrder = useMemo(() => `https://t.me/${config.TG_BOT_NAME}?start=bid_on-${coinSymbol}`, [coinSymbol])

  const updateLocation = (graphId) => {
    const currentPath = location.pathname
    navigateTo(`${currentPath}?cs=${coinSymbol}&gi=g${graphId}`)
  }

  useEffect(() => {
    const assetInfo = LVG_ASSETS.filter((asset) => asset.coinSymbol.toLowerCase() === coinSymbol.toLowerCase()).at(0)
    setAssetInfo(assetInfo)
  }, [coinSymbol, graphId])

  ///--- Web-app integration ------------------------
  const [loading, error] = useScript({ src: 'https://telegram.org/js/telegram-web-app.js' })
  const [isWebAppReady, setIsWebAppReady] = useState(false)

  useEffect(() => {
    if (loading) return
    if (isWebAppReady) return
    window?.Telegram?.WebApp?.ready()
    const isReady = !!window?.Telegram?.WebApp?.initData || false
    if (isReady) window.Telegram.WebApp.expand()
    setIsWebAppReady(isReady)
  }, [loading, isWebAppReady])

  const bidOnYoloBot = () => {
    if (isWebAppReady) window.Telegram.WebApp.openTelegramLink(botUrlPlaceOrder)
    else window.open(botUrlPlaceOrder, '_blank', 'noopener,noreferrer')
  }
  if (loading) return <h3>Connecting...</h3>
  if (error) return <h3>Failed to connect</h3>
  ///---------------------------

  return (
    <YoloBotGraphCSS>
      <YolobotGraphHeader assetInfo={assetInfo} />
      <PriceGraph assetInfo={assetInfo} graphId={grphId} onGraphId={updateLocation} />
      <div className='bottom_yb_graph_buttons'>
        <button href={botUrlPlaceOrder} className='bid_on_yolobot' onClick={bidOnYoloBot}>
          Bid on YOLOBOT
        </button>
        <button className='view_on_yolorekt'>View on YOLOREKT</button>
      </div>
      {/* <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          background: 'black',
          padding: '10px',
          zIndex: '9999999999',
        }}
      >
        <h3 style={{ textDecoration: 'underline' }}> WebApp Info</h3>
        <br />
        <p> isReady: {isWebAppReady ? 'true' : 'false'}</p>
        <p> version: {window?.Telegram?.WebApp?.version}</p>
        <p> platform: {window?.Telegram?.WebApp?.platform}</p>
      </div> */}
    </YoloBotGraphCSS>
  )
}
